export default "__VITE_ASSET__CvPtQcwc__"